import {Component} from "react";

export class SellToWebTableCustomComponent extends Component {
} 
